<script>
import mapboxgl from "mapbox-gl";

export default {
  name: "MglNavigationControl",
  inject: ["map"],
  props: {
    position: {
      type: String,
      default: "top-right",
    },
    showCompass: {
      type: Boolean,
      default: true,
    },
    showZoom: {
      type: Boolean,
      default: true,
    },
  },
  render: (h) => h(),
  data() {
    return {
      control: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.map) return;
      this.control = new mapboxgl.NavigationControl({
        showCompass: this.showCompass,
        showZoom: this.showZoom,
      });
      this.map.addControl(this.control, this.position);
    });
  },
  beforeDestroy() {
    if (this.map && this.control) {
      this.map.removeControl(this.control);
    }
  },
};
</script>
